import {Pipe, PipeTransform} from '@angular/core';
import {Address} from '../../../models/address.model';

@Pipe({
    name: 'addressFull'
})
export class AddressFullPipe implements PipeTransform {

    transform(address: Address): any {
        if (!address) {
            return '';
        }
        const fullAddress = [];
        fullAddress.push(address.street);
        fullAddress.push(address.streetNumber);
        fullAddress.push(address.apartmentNumber ? `/ ${address.apartmentNumber}` : null);
        fullAddress.push(address.postalCode);
        fullAddress.push(address.city);
        return fullAddress
            .filter(Boolean)
            .join(' ')
            .replace(/(^[,\s]+)|([,\s]+$)/g, '');
    }
}
